import type { ColDef } from 'ag-grid-community';

const colDef: ColDef[] = [
  {
    headerName: '',
    colId: 'actions',
    cellRenderer: 'actionsManageCondition',
    editable: false,
    filter: false,
    pinned: 'left',
    suppressMenu: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    width: 90,
  },
];

export default colDef;
